import { createApp } from 'vue'
import App from './Home.vue'
import './registerServiceWorker'

createApp(App).mount('#app')
